import { Box } from "@origin-digital/ods-core";
import React from "react";
import { CategoryImage, Description } from "../../../../components/Category";
import { BreadCrumbs } from "../../../../components/Breadcrumb";

interface ContentSectionProps {
  isLoading?: boolean;
  breadcrumbs: { label: string; url: string }[];
  description: string;
  imageUrl: string;
  name: string;
}

export const ContentSection: React.FC<ContentSectionProps> = (props) => {
  const { isLoading, breadcrumbs, description, imageUrl, name } = props;

  return (
    <Box gap="none" margin="none" paddingLeft={{ xs: "medium", sm: "none" }}>
      <BreadCrumbs breadcrumbs={breadcrumbs} isLoading={isLoading} />
      <Box
        width="full"
        margin="none"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
      >
        <Description
          description={description}
          title={name}
          isLoading={isLoading}
        />
        <CategoryImage imageUrl={imageUrl} isLoading={isLoading} />
      </Box>
    </Box>
  );
};
